import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h2a2 2 0 1 0 0 -4h-2v8","key":"svg-0"}],["path",{"d":"M12 8a2 2 0 0 1 2 2m0 4a2 2 0 1 1 -4 0v-4","key":"svg-1"}],["path",{"d":"M20 16a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1","key":"svg-2"}],["path",{"d":"M3 3l18 18","key":"svg-3"}]]

const IconHttpPostOff = createReactComponent('outline', 'http-post-off', 'HttpPostOff', __iconNode);

export default IconHttpPostOff;